if ($('.article-body').length){

	// Resize article videos
	var $allVideos = $(".article-body iframe[src*='//www.youtube.com'], .article-body iframe[src*='//player.vimeo.com'], .article-body iframe[src*='//player.ooyala.com'], .article-body iframe[src*='//widgets.ign.com']");
	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {
	  $(this)
		.data('aspectRatio', this.height / this.width)

		// and remove the hard coded width/height
		.removeAttr('height')
		.removeAttr('width');
	});

	// Resize all videos according to their own aspect ratio
	$(window).resize(function() {
	  // Resize all videos according to their own aspect ratio
	  $allVideos.each(function() {
		var $el = $(this);
		var newWidth = $el.parent().width();
		$el
		  .width(newWidth)
		  .height(newWidth * $el.data('aspectRatio'));
	  });
	}).resize();

	$(document).ready(function() {

		//article gallery
		$('.article-gallery').slick({
			arrows:false,
			dots:true,
			swipe: false
		});

		//Article facebook share
		$('.facebook-share').click(function(e){
			e.preventDefault();
			FB.ui({
			  method: 'share',
			  href: $(this).data('target')
			});
		});

	});

}
